module.exports = __webpack_public_path__ + "static/img/Exp-FedEx.d7fe8156.png";